import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { shelvesSelectionAction } from 'containers/Configurator/actions/selection';
import reducer from '../reducer';
import { makeSelectMenuOpen } from '../selectors';
import { shelvesSelectionMenuAction } from '../actions';
import { RootState } from 'containers/App/types';
import { useInjectReducer } from 'utils/injectReducer';

interface Props {
  shelvesCabinet: Shelf[];
  selections: number[];
  onBlur: any;
}

interface StateProps {
  menuOpen: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  menuOpen: makeSelectMenuOpen(),
});

function ShelvesSelection({ selections, shelvesCabinet, onBlur }: Props) {
  useInjectReducer({ key: 'shelvesSelectionMenu', reducer: reducer });

  const dispatch = useDispatch();
  //const [menuOpen, setMenuOpen] = useState(true);
  const { menuOpen } = useSelector(stateSelector);

  const isAllSelected =
    selections.length === shelvesCabinet.length || selections.length === 0;

  let select: any;
  const options = [];
  const values = [];
  if (isAllSelected) {
    values.push({ value: 'all', label: `All` });
  } else {
    for (const v of selections) {
      values.push({ value: v, label: `${v + 1}` });
    }
  }

  for (const shelf of shelvesCabinet) {
    options.push({ value: shelf.level, label: `${shelf.level + 1}` });
  }

  const toggleMenuIsOpen = () => {
    dispatch(shelvesSelectionMenuAction(!menuOpen));
    //setMenuOpen(!menuOpen);
    /*  if (select) {
      return !menuOpen ? select.focus() : select.blur();
    }*/
  };

  useEffect(() => {
    if (select) {
      return menuOpen ? select.focus() : select.blur();
    }
  }, [menuOpen]);

  /*
  useEffect(() => {
    dispatch(shelvesSelectionMenuAction(menuOpen));
  }, [menuOpen]);
*/
  const onChange = (value: any, { action, removedValue }: any) => {
    if (value) {
      switch (action) {
        case 'select-option':
          const valuesArray = value
            .filter((item: { value: any }) => item.value !== 'all')
            .map((item: { value: any }) => item.value);
          valuesArray.sort((a: number, b: number) => a - b);
          if (valuesArray.length === shelvesCabinet.length) {
            dispatch(shelvesSelectionAction([]));
            toggleMenuIsOpen();
          } else {
            dispatch(shelvesSelectionAction(valuesArray));
          }

          break;
        case 'remove-value':
        case 'pop-value':
          if (value.length > 0) {
            dispatch(
              shelvesSelectionAction(
                value
                  .filter((item: { value: any }) => item.value !== 'all')
                  .map((item: { value: any }) => item.value),
              ),
            );
          }
          break;
        case 'clear':
          dispatch(shelvesSelectionAction([]));
          value = { value: 'all', label: `All` };
          toggleMenuIsOpen();
          break;
      }
    }
  };

  const styles = {
    multiValue: (base: any, state: any) =>
      state.data.value === 'all' ? { ...base, backgroundColor: 'gray' } : base,
    multiValueLabel: (base: any, state: any) =>
      state.data.value === 'all'
        ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 }
        : base,
    multiValueRemove: (base: any, state: any) =>
      state.data.value === 'all' ? { ...base, isOpen: 'none' } : base,
  };

  return (
    <div>
      <Select
        ref={ref => {
          select = ref;
        }}
        options={options.reverse()}
        isMulti
        closeMenuOnSelect={false}
        isClearable={false}
        isSearchable={false}
        value={values}
        onChange={onChange}
        onBlur={onBlur}
        menuIsOpen={menuOpen}
        autoFocus
        styles={styles}
      />
    </div>
  );
}

export default ShelvesSelection;
